var tag = document.createElement('script');

tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

var videos = [];
var youTubeInitializedPd = false;

function onYouTubeIframeAPIReady() {

    var numOfVideos = $('.homepage-slider .video-container').length;
    
    if (numOfVideos < 1)
        return;

    $('.homepage-slider .video-container').each(function (index) {
        videos[index] = new YT.Player($(this).children('.video').attr('id'), {
            height: '100%',
            width: '100%',
            host: 'https://www.youtube.com',
            videoId: $(this).children('.video').data('video-code'),
            playerVars: {
                rel: '0',
                controls: '0',
                showinfo: '0'
            }
        });
        youTubeInitializedPd = true;
    });

}

function pauseVideo() {
    for (var i = 0; i < videos.length; i++) {
        if (typeof videos[i].pauseVideo == 'function') {
            videos[i].pauseVideo();
        }
    }
}

Vendd.Scripts.load(function () {

    if ($('.home-page .homepage-slider > ul > li').length < 2)
        return;

    initOwlSlider($('.home-page .homepage-slider > ul'), {
        singleItem: true,
        autoPlay: false,
        rewindSpeed: 1500,
        stopOnHover: true,
        autoHeight: true,
        transitionStyle: "fade",
        afterMove: function () {
            if (youTubeInitializedPd)
                pauseVideo();
        }
    });

});
